import { parseDate } from "../../../com/dateUtil";

// 대상자 정보 윈도우
export const ElderInfoWindow = elderInfo => {
  const lastWeek = parseDate("yyyy-mm-dd", new Date(new Date().setDate(new Date().getDate() - 7))).substring(2);
  const today = parseDate("yyyy-mm-dd", new Date(new Date().setDate(new Date().getDate() - 1))).substring(2);
  const bizType = elderInfo.bizType === "5001" ? '<img src="/images/btn-Alm-Set.png"/>' : "";
  const dangerElderYn = elderInfo.dangerElderYn === "Y" ? '<img src="/images/btn-Alm-Bell.png"/>' : "";
  const sickType = elderInfo.sickType === null ? "-" : elderInfo.sickType;
  const protectorTerm = !elderInfo.protectorTerm ? "-" : elderInfo.protectorTerm;
  const protectorPhone = !elderInfo.protectorPhone ? "" : "(" + elderInfo.protectorPhone + ")";
  const note = elderInfo.note === null ? "" : elderInfo.note;
  const weekWarnCnt = elderInfo.weekWarnCnt  === null ? "-" : elderInfo.weekWarnCnt;
  const weekDangerCnt = elderInfo.weekDangerCnt === null ? "-" : elderInfo.weekDangerCnt;
  const weekOffCnt = elderInfo.weekOffCnt === null ? "-" : elderInfo.weekDangerCnt;

  // className 적용 시 해당 CSS 가 적용이 안되는 현상이 있고, react 방식이 아닌 기존 방식의 동적 태그 제작 이므로, class 사용
  const elderInfoWindow =
    '<div class="elderInfoTableDiv">' +
    '<table class="elderInfoTable">' +
    "<thead>" +
    "<tr>" +
    "<th>" +
    "대상자 기본정보" +
    "</th>" +
    "<th>" +
    '<button class="informationBtn" name = "informationBtn"><img src="/images/icon_d.png"/></button>' +
    '<button class="closeInfoBtn" name = "closeInfoBtn"><img src="/images/icon_close.png"/></button>' +
    "</th>" +
    "</tr>" +
    "</thead>" +
    "<tbody>" +
    "<tr>" +
    "<th>이름</th>" +
    "<td>" +
    elderInfo.userTerm +
    // " " +
    // dangerElderYn +
    // " " +
    // bizType +
    "</td>" +
    "</tr>" +
    // "<tr>" +
    // "<th>생년월일</th>" +
    // "<td>" +
    // elderInfo.birthday +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>상세주소</th>" +
    // "<td>" +
    // elderInfo.dongTerm +
    // "  " +
    // elderInfo.address +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>대상자 연락처</th>" +
    // "<td>" +
    // elderInfo.userPhone +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>거주유형</th>" +
    // "<td>" +
    // elderInfo.liveType +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>보유지병</th>" +
    // "<td>" +
    // sickType +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>담당자(연락처)</th>" +
    // "<td>" +
    // elderInfo.managerTerm +
    // "(" +
    // elderInfo.managerPhone +
    // ")" +
    // "</td>" +
    // "</tr>" +
    // "<tr>" +
    // "<th>보호자(연락처)</th>" +
    // "<td>" +
    // protectorTerm +
    // protectorPhone +
    // "</td>" +
    // "</tr>" +
    "<tr>" +
    "<th>*특이사항</th>" +
    "<td>" +
    '<textarea id="elderInfoNote" name="' +
    elderInfo.userId +
    '"' +
    ">" +
    note +
    "</textarea>" +
    '<button id="noteModiBtn"><img src="/images/icon_su.png"/></button>' +
    "</td>" +
    "</tr>" +
    "</tbody>" +
    "</table>" +
    '<table class="elderInfoAlertTable">' +
    "<thead>" +
    "<tr>" +
    '<td colSpan="2" class="elderInfoAlertTableFirstTd">' +
    "<span>" +
    "&nbsp;주간 이벤트 발생&nbsp;<small>(" +
    lastWeek +
    " ~ " +
    today +
    ")</small>" +
    "</span>" +
    "</td>" +
    '<td class="elderInfoAlertTableSecondTd">' +
    "<small>" +
    "<span> (단위:일) &nbsp;&nbsp;</span>" +
    "</small>" +
    "</td>" +
    "</tr>" +
    "</thead>" +
    "<tbody>" +
    "<tr>" +
    "<th>경고</th>" +
    "<th>위험</th>" +
    "<th>미작동</th>" +
    "</tr>" +
    "<tr>" +
    "<td>" +
    weekWarnCnt +
    "</td>" +
    "<td>" +
    weekDangerCnt +
    "</td>" +
    "<td>" +
    weekOffCnt +
    "</td>" +
    "</tr>" +
    "</tbody>" +
    "</table>" +
    "</div>";
  // const meainInfo = '<div class = "meainMarkerInfo" id="iw-'+meain.userId+'-'+meain.ensoTypeCode+'">'
  //                 + '<div class ="meainMarkerInfoHeader">'
  //                 + userTerm
  //                 + '</div>'
  //                 + '<table class="installerMeainPopW ">'
  //                 + '<tbody>'
  //                 + '<tr>'
  //                 + '<th>에너지원</th>'
  //                 + '<td>'+ensoTypeTerm+'</td>'
  //                 + '</tr>'
  //                 + '<tr>'
  //                 + '<th>설비용량</th>'
  //                 + '<td>' + numFormat(roundNum(instCapa ,2 )) + '<span>kW</span></td>'
  //                 + '</tr>'
  //                 + '<tr>'
  //                 + '<th>'+ accumTerm +'</th>'
  //                 + '<td>'+ numFormat(roundNum( accumValue , 2 ))+'<span>MWh</span></td>'
  //                 + '</tr>'
  //                 + '</tbody>'
  //                 + '</table>'
  //                 + '</div>'
  //                 ;

  return elderInfoWindow;
};
